import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export var DownArrow = function (_a) {
    var className = _a.className;
    return (_jsx("svg", { xmlns: 'http://www.w3.org/2000/svg', fill: 'none', viewBox: '0 0 24 24', strokeWidth: '1.5', stroke: 'currentColor', className: className, children: _jsx("path", { strokeLinecap: 'round', strokeLinejoin: 'round', d: 'm19.5 8.25-7.5 7.5-7.5-7.5' }) }));
};
